<template>
  <v-card class="detail-panel" outlined>
    <v-card-title class="pb-2">
      <span>Thẻ của {{ student.fullName }}</span>
      <v-spacer />
      <v-btn icon small @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-card-text class="pa-0">
      <v-skeleton-loader v-if="loading" type="table" />
      <div v-else-if="cards.length === 0" class="pa-4 text-center grey--text">
        Không có thẻ nào
      </div>
      <v-list v-else dense>
        <v-list-item v-for="card in cards" :key="card.id" class="border-bottom">
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{ card.groupName }}
            </v-list-item-title>
            <v-list-item-subtitle class="caption">
              {{ card.totalCards }} thẻ
              <span v-if="card.newCard" class="ml-2">
                | {{ card.newCard }} thẻ mới
              </span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "@/services/axios";

export default {
  name: "StudentCardsPanel",
  props: {
    student: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cards: [],
    };
  },
  watch: {
    student: {
      handler(newStudent) {
        if (newStudent && newStudent.userId) {
          this.fetchStudentCards(newStudent.userId);
        }
      },
      immediate: true,
    },
  },
  methods: {
    async fetchStudentCards(userId) {
      try {
        const res = await axios.get(`admin/student/${userId}/cards`, {
          params: { type: 0 },
        });
        if (res.data.status_code === "200") {
          this.cards = res.data.data || [];
        }
      } catch (err) {
        console.error("Error fetching student cards:", err);
        this.cards = [];
      }
    },
  },
};
</script>

<style scoped>
.detail-panel {
  border-radius: 8px;
  overflow: hidden;
}

.border-bottom {
  border-bottom: 1px solid #eee;
}
</style>
